<template lang="html">
    <div class="editor">
        <div ref="toolbar" class="toolbar" style="width:800px;">
        </div>
        <div ref="editor" class="text" style="height:400px;width:800px;">
        </div>
    </div>
</template>

<script>
import { readImage } from "@/utils/imgCompress.js";
import { mapGetters } from "vuex";
import { uploadFile } from "@/service/user";
import { UPLOAD_CODE } from "@/config/index";
import E from "wangeditor";
export default {
  name: "editoritem",
  data() {
    return {
      // uploadPath,
      editor: null,
      info_: null,
      editorId:null,
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value: function(value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    }
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  computed: {
    ...mapGetters(["permission_siteId"])
  },
  mounted() {
    this.seteditor();
    this.editor.txt.html(this.value);
  },
  methods: {

    seteditor() {
      if (process.env.NODE_ENV === 'development') { 
          this.uploadUrl =process.env.VUE_APP_UPLOAD_ACTION;
      }else{
         this.uploadUrl = window.serverConfig[window.siteMap[domain]].VUE_APP_UPLOAD_ACTION;;
      }
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      this.editor.customConfig = this.editor.customConfig
        ? this.editor.customConfig
        : this.editor.config;
      this.editor.customConfig.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.customConfig.uploadImgServer =
        this.uploadUrl; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {}; // 自定义 header
      this.editor.customConfig.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        //"fontSize", // 字号
        // 'fontName', // 字体
        //"italic", // 斜体
        // "underline", // 下划线
        // "strikeThrough", // 删除线
        // "foreColor", // 文字颜色
        // "backColor", // 背景颜色
        "link", // 插入链接
        //"list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        // "emoticon", // 表情
        // "image", // 插入图片
        // "table", // 表格
        // "video", // 插入视频
        // "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen" // 全屏
      ];
      let self = this;
      //this.editor.customConfig.pasteFilterStyle = true;
      self.editor.customConfig.customUploadImg = function(files, insert) {
        readImage(files[0]).then(res => {
          self.postImg(res, insert);
        });
      };
      self.editor.customConfig.onchange = html => {
        self.info_ = html; // 绑定当前逐渐地值
        self.$emit("change", this.info_); // 将内容同步到父组件中
      };

      // 创建富文本编辑器
      self.editor.create();

      
    },

    async postImg(files, insert) {
      // files是input中选中的文件列表
      const formData = new FormData();
      formData.append("file", files);
      const res = await uploadFile(UPLOAD_CODE.platform, formData);
      var imgUrl ="https://"+res.full_url+"!watermark"; //后台返回的文件路径
      insert(imgUrl); //生成img标签并插入文章中
    }
  }
};
</script>

<style lang="css">
.editor {
  width: 100%;
  position: relative;
  z-index: 0;
  text-align: left;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
}
</style>